
import * as angular from "angular";
import "./formStatusIndicator.scss";

interface IFormStatusIndicatorComponentBindings {
    valid: boolean;
}

class FormStatusIndicatorComponentController implements angular.IComponentController, IFormStatusIndicatorComponentBindings {

    valid: boolean;

    icon: string;
    colorClass: string;

    static $inject = [];

    constructor() {
    }

    $onInit() {
        this.updateModels();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {

        this.updateModels();
    }

    private updateModels() {

        if (this.valid == null || this.valid == undefined || typeof (this.valid ) === 'undefined') {
            this.icon = "warning";
            this.colorClass = "orange-color";

        }
        else if (this.valid === false) {
            this.icon = "clear";
            this.colorClass = "red-color";
        }
        else {
            this.icon = "check";
            this.colorClass = "green-color";
        }
    }
}

export class FormStatusIndicatorComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {

        this.bindings = {
            valid: "<"
        };

        this.controller = FormStatusIndicatorComponentController;

        this.template = require("./formStatusIndicator.html");
    }
}
